import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import { Container, Row, Col, Form, Button, Table } from 'react-bootstrap';
import * as Common from '../Common';
import { width } from '@fortawesome/free-solid-svg-icons/faDownload';

function A2formSP() {
    const { id, location, a2Type } = useParams();
    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);

    const [userRight, setUserRight] = useState([]);
    const [reqData, setReqData] = useState([]);
    const [productData, setProductData] = useState([]);
    const [productDataLrs, setProductDataLrs] = useState([]);
    const [fyData, setFyData] = useState([]);

    const [startYear, setStartYear] = useState(null);
    const [endYear, setEndYear] = useState(null);

    const [totalAmount, setTotalAmount] = useState(0);
    const [totalUSDAmount, setTotalUSDAmount] = useState(0);

    const Style1 = {
        fontSize: '12px',
        textAlign: 'center',
        fontStyle: 'italic',
    };

    const Style2 = {
        fontSize: '12px',
        fontFamily: 'Times New Roman',
    };

    const Style3 = {
        fontSize: '14px',
        fontFamily: 'Times New Roman',
        fontWeight: 'bold',
    };

    const tableStyle = {
        border: '2px solid black',
        borderCollapse: 'collapse',
        width: '100%',
    };

    const tableStyle2 = {
        width: "100%",
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: "#000",
        borderCollapse: "collapse",
    };

    const cellStyle = {
        padding: '6px 35px',
        fontSize: '14px',
        textAlign: 'left',
        border: 'none',
        width: '100%,',
    };

    const cellStyle2 = {
        padding: '1px 1px',
        fontSize: '10px',
        textAlign: 'left',
        // border: 'none',  
        width: '100%,',
        border: '1px solid black'
    };

    const cellStyle3 = {
        padding: '1px 1px',
        fontSize: '10px',
        textAlign: 'left',
        // border: 'none'
        border: '1px solid black'
    };

    const cellStyle4 = {
        padding: '1px 5px',
        fontSize: '10px',
        textAlign: 'left',
        // border: 'none'
        border: '1px solid black'

    };



    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            // Common.callApi(Common.apiRight, [sid, 'all', 'A2FORM'], (result) => {
            //     let resp = JSON.parse(result);
            //     if (resp.query === "1") {
            //         setUserRight(resp);
            Common.callApi(Common.apiA2Form, [sid, 'detail', id, location, a2Type], (result) => {
                let resp = JSON.parse(result);
                setReqData(resp.a2FormValue);
                setStartYear(resp.a2FormValue[0]['start_year']);
                setEndYear(resp.a2FormValue[0]['end_year']);
                setFyData(resp.fyDetail);

                const products = resp.a2ProductValue || [];
                setProductData(products);
                setProductDataLrs(resp.a2ProductLrs || []);

                // Calculate totals here 
                const amount = products.reduce((sum, item) => sum + Number(item.prd_amount || 0), 0);
                const USDAmount = products.reduce((sum, item) => sum + Number(item.prd_usd_amount || 0), 0);

                setTotalAmount(amount);
                setTotalUSDAmount(USDAmount);

                // setTotalAmount(parseFloat(amount.toFixed(2)));
                // setTotalUSDAmount(parseFloat(USDAmount.toFixed(2)));
            });
        }
    }, [sid]);

    return (
        <>
            <Container fluid>
                <Row>
                    <Col style={Style1}>
                        FORM A2 and Application cum Declaration for purchase of foreign exchange under Liberalized Remittance Scheme(LRS) as amended<br />
                        by RBI vide Master Direction-LRS dated June 20, 2018 for <b>INDIAN PASSPORT HOLDER</b> <br />
                        (To be completed by the applicant in BLOCK letters)
                    </Col>
                </Row>
                <Row>
                    <Col style={Style3}>
                        Date : {reqData?.[0]?.hdr_date}
                    </Col>

                </Row>
                <Row>
                    <Col style={Style3}>
                        The Branch Manager
                    </Col>
                </Row>
                <Row>
                    <Col style={Style3}>
                        {fyData?.[0]?.fy_name}({reqData?.[0]?.entity_name})<br />
                        {reqData?.[0]?.entity_address1} <br />
                        {reqData?.[0]?.entity_address2}{reqData?.[0]?.entity_address2}<br />
                        {reqData?.[0]?.entity_branch}
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={Style3}>
                        <b>Dear Sir,<br />
                            Subject : Release of Foreign Exchange for {reqData?.[0]?.purpose_name} Visit purpose.</b>
                    </Col>
                </Row>
                <Row>
                    <Col style={Style2}>
                        With reference to the above I request you to release foreign exchange for the purpose mentioned above and furnish the following details:
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={Style3}>
                        1. Details of Applicant/Remitter
                    </Col>
                </Row>
                <Row>
                    <Col style={Style2}>
                        Applicant Name : <u> {reqData?.[0]?.bd_name} </u>
                    </Col>
                    <Col style={Style2}>
                        Date of Birth : <u> {reqData?.[0]?.bd_birth_date}</u>
                    </Col>
                </Row>
                <Row>
                    <Col style={Style2}>
                        Address : <u>{reqData?.[0]?.bd_address}</u>
                    </Col>
                </Row>
                <Row>
                    <Col style={Style2}>
                        City : <u>{reqData?.[0]?.city_name}</u>
                    </Col>
                    <Col style={Style2}>
                        Pin Code : <u>{reqData?.[0]?.bd_pin} </u>
                    </Col>
                </Row>
                <Row>
                    <Col style={Style2}>
                        State : <u>{reqData?.[0]?.state_name} </u>
                    </Col>
                    <Col style={Style2}>
                        Mobile No. : <u>{reqData?.[0]?.bd_mobile} </u>
                    </Col>
                </Row>
                <Row>
                    <Col style={Style2}>
                        Email ID. : <u>{reqData?.[0]?.bd_email} </u>
                    </Col>
                    <Col style={Style2}>
                        Nationality : <u>{reqData?.[0]?.cnt_nationality}</u>
                    </Col>
                </Row>
                <Row>
                    <Col style={Style2}>
                        Residential Status : <u>{reqData?.[0]?.mrs_resident}</u>
                    </Col>
                    <Col style={Style2}>
                        PAN No. : <u> {reqData?.[0]?.bd_pan} </u>
                    </Col>
                </Row>
                <Row>
                    <Col style={Style2}>
                        Passport No. : <u>{reqData?.[0]?.mpid_id_number} </u>
                    </Col>
                    <Col style={Style2}>
                        Date of Expiry : <u>{reqData?.[0]?.mpid_expiry_date} </u>
                    </Col>
                </Row>
                <Row>
                    <Col style={Style2}>
                        Place of Issue : <u>{reqData?.[0]?.mpid_issue_place} </u>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={Style3}>2. Foreign exchange amount to be released/ remitted (Please provide the exact split)</Col>
                </Row>
                <Row>
                    {/* <Table responsive striped> */}
                    <Table style={tableStyle}>
                        <tbody>
                            <tr>
                                {
                                    productData.length > 0 ?
                                        <>
                                            {
                                                productData.map((res, index) => (
                                                    <tr>
                                                        {/* <td style={borderStyle}>{index + 1}</td> */}
                                                        <td style={cellStyle}>{res.prd_isd}</td>
                                                        <td style={{ ...cellStyle, width: '100%' }}>{res.isd_name} </td>
                                                        <td style={cellStyle}>{res.prd_product} </td>
                                                        <td style={cellStyle}>{res.prd_qty}</td>
                                                        <td style={cellStyle}>{res.prd_amount}</td>
                                                    </tr>
                                                ))
                                            }
                                        </>
                                        : null
                                }
                            </tr>
                        </tbody>
                    </Table>
                </Row>
                <Row>
                    {/* <Col style={Style2}>
                        Equivalent to Rs. <u>{Number(totalAmount || 0).toFixed(2)}</u>
                    </Col>
                    <Col style={Style2}>
                        Equivalent to USD <u>{Number(totalUSDAmount || 0).toFixed(2)}</u>
                    </Col> */}

                    <Col style={Style2}>
                        Equivalent to Rs. <u>{(totalAmount ?? 0).toFixed(2)}</u>
                    </Col>
                    <Col style={Style2}>
                        Equivalent to USD <u>{(totalUSDAmount ?? 0).toFixed(2)}</u>
                    </Col>

                </Row>
                <Row>
                    <Col style={Style2}>
                        Country of Travel: <u>{reqData?.[0]?.cnt_name}</u>
                    </Col>
                    <Col style={Style2}>
                        Date of Travel: <u>{reqData?.[0]?.hdr_departure_date}</u>
                    </Col>
                </Row>
                <Row>
                    <Col style={Style2}>
                        Source of Funds: <u>{reqData?.[0]?.msf_source_of_fund}</u>
                    </Col>
                    <Col style={Style2}>
                        Relationship with the Applicant: <u>{reqData?.[0]?.rel_name}</u>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>


                <Row>
                    <Col style={Style3}>3. Foreign exchange amount released/ remitted under the LRS in the current financial year.</Col>
                </Row>
                <Row>
                    {/* <Table responsive striped> */}
                    <Table style={tableStyle2}>
                        <thead>
                            <tr>
                                <th style={cellStyle4} rowSpan={2}>Sr No  </th>
                                <th style={cellStyle2} rowSpan={2}>Date&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                                <th style={cellStyle2} rowSpan={2}>FCN & Amount</th>
                                <th style={cellStyle2} rowSpan={2}>Equivalent to Rs. </th>
                                <th style={cellStyle2} rowSpan={2}>Equivalent to USD </th>
                                <th style={cellStyle3} >Name and address of AD branch/FFMC through </th>
                            </tr>
                            <tr>
                                <th style={cellStyle3}>which the transaction has been effected</th>
                            </tr>
                        </thead>
                        <tbody>

                            {/* Hardcoded Rows */}
                            <tr>
                                <td style={{ ...cellStyle2, height: "30px" }}></td>
                                <td style={{ ...cellStyle4, height: "30px" }}></td>
                                <td style={{ ...cellStyle2, height: "30px" }}></td>
                                <td style={{ ...cellStyle2, height: "30px" }}></td>
                                <td style={{ ...cellStyle2, height: "30px" }}></td>
                                <td style={{ ...cellStyle2, height: "30px" }}></td>
                            </tr>
                            <tr>
                                <td style={{ ...cellStyle2, height: "30px" }}></td>
                                <td style={{ ...cellStyle2, height: "30px" }}></td>
                                <td style={{ ...cellStyle2, height: "30px" }}></td>
                                <td style={{ ...cellStyle2, height: "30px" }}></td>
                                <td style={{ ...cellStyle2, height: "30px" }}></td>
                                <td style={{ ...cellStyle2, height: "30px" }}></td>
                            </tr>

                            {/* Dynamic Rows */}
                            {
                                productDataLrs.length > 0 ?
                                    <>
                                        {
                                            productDataLrs.map((res, index) => (
                                                <tr key={index}>
                                                    <td style={cellStyle4}>{index + 3}</td>
                                                    <td style={cellStyle2}>{res.hdr_date}</td>
                                                    <td style={cellStyle2}>{res.prd_isd} {res.prd_qty}</td>
                                                    <td style={cellStyle2}>{res.prd_amount}</td>
                                                    <td style={cellStyle2}>{res.prd_usd_amount}</td>
                                                    <td style={cellStyle2}>{res.entity_name}</td>
                                                </tr>
                                            ))
                                        }
                                    </>
                                    : null
                            }

                        </tbody>
                    </Table>
                </Row>
                <Row>&nbsp;</Row>
                <Row>&nbsp;</Row>


                <div style={{ display: 'block', breakBefore: 'page', pageBreakBefore: 'always', clear: 'both' }}></div>
                <Row>
                    <Col style={{ fontSize: '18px', fontWeight: 'bold', textAlign: 'center' }}>
                        Declaration cum undertaking
                    </Col>
                </Row>
                <Row>
                    <Col style={Style2}>
                        I, the undersigned, hereby declare that the total amount of foreign exchange purchased from or remitted through, all sources in india during the financial year as per item no. 4 of the Application, including the current transaction is within the overall limit of USD 250,000/-(USD Dollar Two Hundred and Fifty Thousand Only), which is the limit prescribed by the Reserve Bank of India for the said purpose. I certify that the source of funds for making the said remittance belongs to me and the foreign exchange shall not be used for prohibited purposes. The transaction details of which are mentioned above does not involve, and is not designed for the purpose of any contravention or evasion of the provisions of the FEMA, 1999 or of any Rule, Regulation, Notification, Direction or Order made there under. I also hereby agree and undertake to provide such information / documents as will reasonably satisfy you about this transaction in terms of this declartion. I shall be responsible and liable for any incorrect infomation provided by me. I agree that in the event the transaction is cancelled or revoked by me after submitting the request, any exchange losses incurred in tehis connection to be recovered from the refund amount. I further agree that once the funds remitted by me have been tranmitted by Zenith Leisure Holidays Limited (through AD Bank) to the conrrespondent and/or beneficiary banks, shall not be responsible for any delays in the disbursement of such funds including the withholding of such funds by the correspondent and/or Beneficiary bank because of incorrct information subitted by me, any charges levied by the beneficiary bank or exchange losses incurred in this connection, I  will be liable to pay the same to Zenith Leisure Holidays Limited. I further confirm that the foreign exchange released for above mentioned purpose will be used within 60 days of purchase. In case it is not possible to use the foreign exchange withing the period of 60 days, same will be surrendered to an authorized person. I am neither a politically Explosed Person (PEP), not related to any of the Pep's. I hereby give my consent for sharing details/documents/information provided by us regardsto this transaction with the AD I bank thru which remittance will processed and for the AD I bank to use, disclose, store and/or process such information, including for undertaking any verification, checks, authentication etc. Also to share the information with Regulator or any Law Enforcing Agencies wherever asked for as per extent Law/Rules/directions/Guidelines. In case of payment by cash I hereby declare that the aggregate value of foreign exchagne purchased by me, including this particular transaction, during the last 30 days, including the present date, either from Zenith Leisure Holidays Limited or from any other Authorized Dealers, by making payment in Cash does not exceed Rs. 50,000/-.
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={Style2}>
                        I understand that it is mandatory for you to collect copy of my visa and ticket before release of foreign exchange and keep the same on record. In this case, the VISA will be i) stamped only after the endorsement of availing exchange ii) on arrival at the after my return from trip as a proof of obtaining visa as well as undertaking the trip aborad.
                    </Col>
                </Row>
                <Row>&nbsp;</Row>

                <Row>
                    <Col style={Style2}>
                        Whether the total remittance made outside India during the current financial year, through all banks / Reserve Bank of India Authorised Dealers / financial institutions / NBFCs, exceeds Rs. 10 Lakhs?
                    </Col>
                </Row>
                {/* <Row>
                    <Col style={Style3}>
                        Payment for the above mentioned foreign exchange will be paid by M/s Avanse Financial Services Limited from my Overseas Education Loan A/c No._____________________________directly to Zenith Leisure Holidays Limited on my behalf.
                    </Col>
                </Row> */}
                <Row>&nbsp;</Row>
                {/* <Row>&nbsp;</Row> */}
                <Row>
                    <Col style={Style3}>
                        ___________________________
                        <span style={{ marginLeft: '13%' }}>
                            ____________________________________________
                        </span><br />
                        Signature of the applicant
                        <span style={{ marginLeft: '13%' }}>
                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Signature of the natural guardian (if applicant is minor)
                        </span><br />
                        Name : {reqData?.[0]?.bd_name}
                        <span style={{ marginLeft: '30%' }}>
                            Name: &nbsp; &nbsp; _________________________
                        </span><br />
                        <span style={{ marginLeft: '41%' }}>
                            Relationship with the Applicant: ______________________
                        </span>
                    </Col>
                </Row>
                <Row>
                    <Col style={Style3}>
                        <hr />
                        <center>Certificate by the Authorized Dealer</center>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={Style2}>
                        This is to certify that the remittance is not being made by/to ineligible entities and that the remittance is in conformity with the instructions issued by the Reserve Bank from time to time under the Scheme. I have verified KYC documents in original.
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={Style2}>
                        Name and designation of the authorized official:
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={Style2}>
                        ______________<br />
                        &nbsp; &nbsp; &nbsp; Signature
                    </Col>
                    <Col style={Style2}>
                        <u>{reqData?.[0]?.hdr_date}</u><br />
                        &nbsp; &nbsp; &nbsp; Date
                    </Col>
                    <Col style={Style2}>
                        <u> {reqData?.[0]?.entity_branch}</u><br />
                        &nbsp; &nbsp; &nbsp; Place
                    </Col>
                    <Col style={Style2}>
                        ___________________<br />
                        &nbsp; &nbsp; &nbsp; Stamp & seal
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
            </Container>
        </>
    )
}
export default A2formSP;